var _rect, _path, _path2, _path3, _rect2, _rect3, _circle, _circle2, _ellipse, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFish(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    transform: "translate(0 0.5)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8842 18.7192V8.70864C16.8842 6.38427 18.7685 4.5 21.0929 4.5H31.6343C41.6603 4.5 49.7881 12.6278 49.7881 22.6538L16.8842 18.7192Z",
    fill: "#9069CD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 20.6001H5.77212C11.2829 20.6001 15.7502 25.0674 15.7502 30.5782V33.615H10.9781C5.46733 33.615 1 29.1476 1 23.6369V20.6001Z",
    fill: "#9069CD",
    stroke: "#9069CD",
    strokeWidth: 1.99908,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 43.1587H5.77212C11.2829 43.1587 15.7502 38.6913 15.7502 33.1806V30.1438H10.9781C5.46733 30.1438 1 34.6111 1 40.1219V43.1587Z",
    fill: "#9069CD",
    stroke: "#9069CD",
    strokeWidth: 1.99908,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 11.5,
    width: 48,
    height: 41,
    rx: 20.5,
    fill: "#CE82FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 54,
    y: 21.5,
    width: 6,
    height: 21,
    rx: 3,
    fill: "#9069CD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45.601,
    cy: 24.3891,
    r: 4.88909,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.6015,
    cy: 24.3891,
    r: 3.11124,
    fill: "#4B4B4B"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.644,
    cy: 51.7436,
    rx: 6.14812,
    ry: 4.39151,
    transform: "rotate(135 39.644 51.7436)",
    fill: "#9069CD",
    stroke: "#9069CD",
    strokeWidth: 2.5801,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2139 39.3944C20.2139 40.5775 20.942 41.3359 22.1554 41.3359H28.3441C32.8036 41.3359 35.5035 39.3944 35.5035 35.3293C35.5035 32.872 34.108 31.2035 32.7429 30.6575V30.5968C34.1384 29.8384 35.1395 28.4126 35.1395 26.198C35.1395 22.9217 33.0463 20.7071 28.5564 20.7071H22.1554C20.942 20.7071 20.2139 21.4958 20.2139 22.679V39.3944ZM24.8554 29.1406C24.734 29.1406 24.6734 29.08 24.6734 28.9586V24.4992C24.6734 24.3778 24.734 24.3171 24.8554 24.3171H27.9801C29.7092 24.3171 30.7103 25.1666 30.7103 26.7137C30.7103 28.2609 29.6789 29.1406 27.9801 29.1406H24.8554ZM24.6734 37.5439V32.7507C24.6734 32.6293 24.734 32.5687 24.8554 32.5687H28.2227C30.0429 32.5687 31.044 33.5698 31.044 35.1169C31.044 36.7551 30.0429 37.7259 28.2227 37.7259H24.8554C24.734 37.7259 24.6734 37.6652 24.6734 37.5439Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFish);
export default __webpack_public_path__ + "static/media/icon-fish.d850234b2111c5deb732ee0309ca410e.svg";
export { ForwardRef as ReactComponent };